module.exports = __webpack_public_path__ + "img/share.cd2ceb8e.svg";